import { IOptionValue } from "./interfaces/option-value";
import { IOptionValueQuestionGroup } from "./interfaces/option-value-question-group";
import { IAssessmentMessage } from "./interfaces/assessment-message";

export class OptionValue implements IOptionValue {
  constructor(
    optionId?: number,
    description?: string,
    index?: number,
    score?: number) {
    this.index = index != undefined ? index : 0;
    this.description = description != undefined ? description : "";
    this.optionId = optionId != undefined ? optionId : 0;
    this.score = score != undefined ? score : 0;
    this.optionValueQuestionGroups = [];
    this.assessmentMessages = [];
  }

  optionValueId: number;
  optionId: number;
  isSelected: boolean;
  description: string;
  score: number;
  helpText: string;
  optionValueQuestionGroups: IOptionValueQuestionGroup[];
  assessmentMessages: IAssessmentMessage[];
  index: number;
  isDeleted: boolean;
  isHighRiskCategory: boolean;
  partnerTypeId: number;
  onwardReferralSummary: string;

  isValid(): boolean {
    var valid = this.description != "" && this.optionId > 0 && this.index > 0;
    var opValQGrpsValid = true;
    var amValid = true;

    if (this.optionValueQuestionGroups) {
      this.optionValueQuestionGroups.forEach(ovqg => {
        if (!ovqg.isValid()) {
          opValQGrpsValid = false;
        }
      });
    }
       
    if (this.assessmentMessages) {
      this.assessmentMessages.forEach(am => {
        if (!am.isValid()) {
          amValid = false;
        }
      });
    }
    
    return valid && opValQGrpsValid && amValid;
  }

  prepare(): void {
    if (this.index < 1) {
      this.index = 1;
    }

    for (let i = 0; i < this.optionValueQuestionGroups.length; i++) {
      this.optionValueQuestionGroups[i].index = i + 1;
      this.optionValueQuestionGroups[i].optionValueId = this.optionValueId;
      this.optionValueQuestionGroups[i].questionGroup = null;
    }

    for (let i = 0; i < this.assessmentMessages.length; i++) {
      this.assessmentMessages[i].index = i + 1;
      this.assessmentMessages[i].optionValueId = this.optionValueId;
    }

    if (!this.isDeleted) {
      this.isDeleted = false;
    }

    if (!this.isSelected) {
      this.isSelected = false;
    }

    if (!this.score) {
      this.score = 0;
    }
  }
}
